import * as React from "react";
import {Button, DialogTitle, Dialog, DialogContent, Typography} from "@mui/material";
import { styled } from "@mui/material/styles";
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import DialogActions from '@mui/material/DialogActions';

type Props = {
    selected: any;
    open: any;
    handleClose: any;
    handleDelete: any;
    availableRecordsCount?: number;

};

export const DeleteCollection = ({
    selected,
    open,
    handleClose,
    handleDelete,
    availableRecordsCount = 0,
    ...props
}: Props) => {

    const StyledButton = styled(Button)({
        borderRadius: "4px",
        textTransform: "none",
        flexGrow: 1,
        maxWidth: '100px',
        maxHeight: '40px',
        minWidth: '100px',
        minHeight: '40px'
    });

    const StyledDialog = styled(Dialog)(({ theme }) => ({
        '& .MuiDialogContent-root': {
            padding: theme.spacing(2),
        }
    }));

    // Check if this is the last available queue
    const isLastAvailableQueue = availableRecordsCount === 1 && 
        (selected?.data?.availability === "AVAILABLE" || selected?.data?.availability === true) &&
        selected?.data?.type === "LOCAL_COLLECTION";

    // Check if queue has remaining cases
    const hasRemainingCases = selected?.data?.type === "LOCAL_COLLECTION" && 
        selected?.data?.remaining_cases > 0;

    const getDialogTitle = () => {
        if (isLastAvailableQueue) {
            return "Cannot Delete Last Queue";
        }
        return "Are you sure?";
    };

    const getDialogContent = () => {
        if (isLastAvailableQueue) {
            return "This is the last active queue and cannot be deleted. Please create a new queue or activate another existing queue before deleting this one.";
        }
        
        if (hasRemainingCases) {
            return (
                <>
                    <Typography>
                        {selected?.data?.remaining_cases} case{selected?.data?.remaining_cases !== 1 ? 's' : ''} 
                        {' '}will be automatically redistributed to other available queues based on the configured criteria.
                    </Typography>
                </>
            );
        }

        return (
            <Typography gutterBottom sx={{mb: 2}}>
                Delete queue {selected?.data?.name}?
            </Typography>
        );
    };

    return (
        <StyledDialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
            <DialogTitle sx={{ m: 0, p: 2 }} id="reassign-title">
                {getDialogTitle()}
            </DialogTitle>
            <IconButton
                aria-label="close"
                onClick={handleClose}
                sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: (theme) => theme.palette.grey[500],
                }}
            >
                <CloseIcon />
            </IconButton>
            <DialogContent>
                {getDialogContent()}
            </DialogContent>
            <DialogActions sx={{ padding: "16px  24px" }}>
                {isLastAvailableQueue ? (
                    <StyledButton variant="contained" onClick={() => handleClose()}>
                        OK
                    </StyledButton>
                ) : (
                    <>
                        <StyledButton variant="outlined" onClick={() => handleClose()}>
                            Cancel
                        </StyledButton>
                        <StyledButton variant="contained" sx={{ml: 5}} onClick={() => handleDelete(selected)}>
                            Delete
                        </StyledButton>
                    </>
                )}
            </DialogActions>
        </StyledDialog>
    )
}
